


export const _zzyourmap_ymDataRespack_validator_quick_incomplete = (ymDataRespack) => {
  let valid = true;
  if (ymDataRespack && ymDataRespack.thisis === 'ymDataRespack' && ymDataRespack.rows_decoded_backend && Array.isArray(ymDataRespack.rows_decoded_backend) && ymDataRespack.separated_entities_pack) {
    // is valid so far
  } else {
    valid = false;
  }
  return valid;
};